var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.523 6.39793L7.14803 9.77293C7.04236 9.8786 6.89904 9.93797 6.74959 9.93797C6.60015 9.93797 6.45683 9.8786 6.35116 9.77293C6.24548 9.66726 6.18612 9.52393 6.18612 9.37449C6.18612 9.22505 6.24548 9.08173 6.35116 8.97605L8.76569 6.56246H1.87506C1.72588 6.56246 1.5828 6.5032 1.47731 6.39771C1.37182 6.29222 1.31256 6.14914 1.31256 5.99996C1.31256 5.85078 1.37182 5.7077 1.47731 5.60221C1.5828 5.49672 1.72588 5.43746 1.87506 5.43746H8.76569L6.35209 3.02246C6.24642 2.91679 6.18705 2.77347 6.18705 2.62402C6.18705 2.47458 6.24642 2.33126 6.35209 2.22558C6.45776 2.11991 6.60109 2.06055 6.75053 2.06055C6.89997 2.06055 7.0433 2.11991 7.14897 2.22558L10.524 5.60058C10.5764 5.65291 10.618 5.71509 10.6464 5.78354C10.6747 5.85199 10.6893 5.92536 10.6892 5.99945C10.6891 6.07354 10.6744 6.14688 10.6459 6.21527C10.6173 6.28365 10.5756 6.34572 10.523 6.39793Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.cb321079fb490bf62a564635d307ae45.svg";
export { ForwardRef as ReactComponent };